module.exports = __webpack_public_path__ + "static/media/wipro-logo.13c096fc.png";